import Auth, { FetchAPI, ParamsSerializer } from './auth-service';

class UpgradeDataService {
    constructor () {
        // we only need one of these
        if (!UpgradeDataService.instance) {
            UpgradeDataService.instance = this;
        }
        this.searchPlaceholder = 'Search upgrades';

        this.uploadUpgradeFile = (app, content) => {
            if (!content) {
                return Promise.reject(new Error('No content'));
            }
            const a = Auth.getAuth();
            const form = new FormData();
            form.append('fileblob', content);
            form.append('name', content.name);

            return fetch(`/api/system/upgrades/files/${app}`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${a.token}`,
                },
                body: form,
            }).then((response) => {
                return response.text().then(text => {
                    let data = text;
                    try {
                        data = text && JSON.parse(text);
                    } catch (err) {
                        // response isn't json
                        if ((text || '').trim() !== 'null') {
                            data = text;
                        }
                    }
                    if (!response.ok) {
                        const error = data || response;
                        return Promise.reject(error);
                    }
                    return data;
                });
            }).catch(error => {
                if ([401, 403].indexOf(error.status) !== -1) {
                    return Auth.boot();
                }
                return Promise.reject(error);
            });
        };

        this.listUpgradeFiles = (app, group) => {
            return FetchAPI({
                url: `system/upgrades/files/${app}/${group}/`,
                method: 'GET',
            });
        };

        this.validateUpgradeFile = (app, name, group) => {
            return FetchAPI({
                url: `system/upgrades/files/${app}/${ParamsSerializer(name)}/${group}`,
                method: 'GET',
            });
        };

        this.deployUpgradeFile = (app, name, group) => {
            return FetchAPI({
                url: `system/upgrades/files/${app}/${name}/${group}`,
                method: 'PUT',
            });
        };

        this.deleteUpgradeFile = (app, type, name, group) => {
            return FetchAPI({
                url: `system/upgrades/files/${app}/${type}/${name}/${group}`,
                method: 'DELETE',
            });
        };

        this.getUpgradeSchedule = (app, group) => {
            return FetchAPI({
                url: `system/upgrades/schedule/${app}/${group}`,
                method: 'GET',
            });
        };

        this.updateUpgradeSchedule = (app, group, schedule) => {
            return FetchAPI({
                url: `system/upgrades/schedule/${app}/${group}`,
                method: 'PUT',
                body: schedule,
            });
        };

        this.getUpgradeStatus = (app) => {
            return FetchAPI({
                url: `system/upgrades/status/${app}`,
                method: 'GET',
            });
        };

        return UpgradeDataService.instance;
    }
}

const UpgradeService = new UpgradeDataService();

export default UpgradeService;
